import { withDrawerLayout } from '@/shared/lib';
import { t } from 'ttag';

/**
 * Drawer explaining the patient impact levels selectable on an RMA. Wraps a static set of paragraphs - None, Medical Intervention, Patient Death, Patient Injury and Unknown - with their descriptions in withDrawerLayout.
 *
 * @returns The patient impact reference drawer component.
 */
const PatientImpactDrawer = withDrawerLayout(() => (
  <div className="patient-impact-drawer-body">
    <div className="paragraph">
      <div className="title">{t`None`}</div>
      <div className="content">{t`No impact from the use of the device.`}</div>
    </div>

    <div className="paragraph">
      <div className="title">{t`Medical Intervention`}</div>
      <div className="content">
        {t`The patient required medical intervention to prevent injury or death from the use of the device.`}
      </div>
    </div>

    <div className="paragraph">
      <div className="title">{t`Patient Death`}</div>
      <div className="content">
        {t`The patient suffered lethal damage from the use of the device.`}
      </div>
    </div>

    <div className="paragraph">
      <div className="title">{t`Patient Injury`}</div>
      <div className="content">
        {t`The patient suffered injury or bodily impairment sustained from the use of the device (e.g., shock, burn, allergic reaction, choking, etc.).`}
      </div>
    </div>

    <div className="paragraph">
      <div className="title">{t`Unknown`}</div>
      <div className="content">{t`The impact on the patient is undefined.`}</div>
    </div>
  </div>
));

(PatientImpactDrawer as any).defaultProps = {
  className: 'patient-impact-drawer-v2',
  title: t`Patient impact`,
};

export default PatientImpactDrawer;
